import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { HttpClient } from '@angular/common/http';

@Injectable({
providedIn: 'root',
})
export class TimeAddService
{
  private lastDateSelectedSubject = new BehaviorSubject<DateTime>(DateTime.local());
  lastDateSelected$ = this.lastDateSelectedSubject.asObservable();

  constructor(private http: HttpClient) { }

  setLastDateSelected(date: DateTime)
  {
    this.lastDateSelectedSubject.next(date);
  }

  getLastDateSelected(): DateTime {
    return this.lastDateSelectedSubject.getValue();
  }
}
